export default __webpack_public_path__ + "static/media/leovictime.62253ac8.png";